import { Component, DestroyRef, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { NotyService } from './noty.service';
import { INoty } from './noty.interface';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IconComponent } from "../icon/icon.component";


@Component({
  selector: 'noty',
  templateUrl: './noty.component.html',
  styleUrls: ['./noty.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent]
})
export class NotyComponent implements OnInit {
  private notyService = inject(NotyService);

  noties = signal<INoty[]>([]);
  private counter: number = 0;
  private timeToAutoHide: number = 5000;
  private timeToErrorAutoHide: number = 15000;
  private autoHideTimeout: ReturnType<typeof setTimeout>;

  private readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.notyService.showNoty$
      .pipe( takeUntilDestroyed(this.destroyRef) )
      .subscribe(
        noty => {
          this.showNoty({
            id: this.counter++,
            isHiding: false,
            ...noty
          });
        }
      );
  }

  private showNoty(noty: INoty) {
    clearTimeout(this.autoHideTimeout);
    this.noties.update(list => [...list, noty]);

    const timeToAutoHide = noty.type === 'error' ? this.timeToErrorAutoHide : this.timeToAutoHide;
    setTimeout(() => this.hideNoty(noty), timeToAutoHide);
    this.autoHideTimeout = setTimeout(() => this.removeAllNotiesExcept(noty), 300);
  }

  hideNoty(noty: INoty) {
    noty.isHiding = true;

    setTimeout(() => {
      this.noties.update(list => list.filter(item => item.id !== noty.id));
    }, 1000);
  }

  private removeAllNotiesExcept(notyArg: INoty) {
    this.noties.update(list => list.filter(noty => noty.id === notyArg.id));
  }
}
